import { fg } from '@atlaskit/platform-feature-flags';

import type { CollectionType, Product } from '../types';

// TODO: update this logic once we have collection type identification method https://hello.jira.atlassian.cloud/browse/SEQA-177
export const getProductCollection = (
	product: Product,
): { collectionType: CollectionType; isEnabled: boolean } | undefined => {
	switch (product) {
		case 'jira-service-management':
			return { collectionType: 'Service Collection', isEnabled: fg('servco-xflow-ga') };
		case 'jira':
		case 'confluence':
			return {
				collectionType: 'Teamwork Collection',
				isEnabled: true,
			};
		default:
			return undefined;
	}
};
